import {  LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { ContractStatusKeys } from "../../_helpers";
import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LabelColumnV2, LinkColumnV2 } from "../../components/DataGridV2/DataColumnsV2";

export const getContractOverviewColumns = ({ t,
    theme,
    keyPrefix,
    i18n,
    apiRef,
    scriveStatuses
  }) => {
    const getOptions = getGridContextMenuList({
        filterKey: LOCAL_STORAGE_GRID_KEYS.CONTRACT_OVERVIEW_LIST_COLUMN_FILTER[keyPrefix],
        sortKey: LOCAL_STORAGE_GRID_KEYS.CONTRACT_OVERVIEW_LIST_COLUMN_SORT[keyPrefix],
        i18n,
        t,
        apiRef,
        getValueForCopy: (rowData, extraData) => {
            let text = ""
            switch (extraData.fieldName) {
              case "status":
               text = t(`contact.status.${rowData?.status}`)
              break;
              default:
                text = rowData[extraData.fieldName]
                break;
            }
            return text
          },
        getValueForFilter: (rowData, extraData) => {
            let value = ""
            switch (extraData.fieldName) {
                default:
                    value = rowData?.[extraData?.fieldName]
                    break;
            }
            return value
        },
        mode: "client"
      })   
    
    return [
         {
            field: "projectNo",
            headerName: t("general.projectNumber"),
            flex: 1,
            minWidth: 110,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                 label={rowData.projectNo}
                 cellSubMenuOptions={{ options: getOptions({ field: "projectNo", isQuickFilterDisplay: Boolean(rowData.projectNo) }), extraData: { fieldName: "projectNo" } }}
                 request={rowData}
                 />
            },
        },
        {
            field: "projectName",
            headerName: t("general.projectName"),
            flex: 1,
            minWidth: 110,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                 label={rowData.projectName}
                 cellSubMenuOptions={{ options: getOptions({ field: "projectName", isQuickFilterDisplay: Boolean(rowData.projectName) }), extraData: { fieldName: "projectName" } }}
                 request={rowData}
                 />
            },
        },
        {
            field: "objectNumber",
            headerName: t('general.objectNumber'),
            flex: 1,
            minWidth: 90,
            download: true,
             renderCell: (params) => {
                      const rowData = params.row;
                      return (
                        <LinkColumnV2
                          label={rowData.objectNumber}
                          cellSubMenuOptions={{
                            options: getOptions({ field: "objectNumber", isQuickFilterDisplay: Boolean(rowData.objectNumber) }),
                            extraData: { fieldName: "objectNumber" } 
                        }}
                        request={rowData}
                        />
                      );
                    },
        },
         {
            field: "buyer",
            headerName: t("general.buyer"),
            flex: 1,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2 
                label={rowData.buyer}
                cellSubMenuOptions={{ options: getOptions({ field: "buyer", isQuickFilterDisplay: Boolean(rowData.buyer) }), extraData: { fieldName: "buyer" } }}
                request={rowData}
                 />
            },
        },
         {
            field: "seller",
            headerName: t("general.seller"),
            flex: 1,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2 
                label={rowData.seller}
                cellSubMenuOptions={{ options: getOptions({ field: "seller", isQuickFilterDisplay: Boolean(rowData.seller) }), extraData: { fieldName: "seller" } }}
                request={rowData}
                 />
            },
        },
         {
            field: "salesRepresentative",
            headerName: t("general.responsible"),
            flex: 1,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2 
                label={rowData.salesRepresentative}
                cellSubMenuOptions={{ options: getOptions({ field: "salesRepresentative", isQuickFilterDisplay: Boolean(rowData.salesRepresentative) }), extraData: { fieldName: "salesRepresentative" } }}
                request={rowData}
                 />
            },
        },
        {
            field: "creationDate",
            headerName: t('general.creationDate'),
            flex: 1,
            minWidth: 90,
            type: "dateTime",
            valueGetter: (params) => {
                if (!params) return "";
                return new Date(params);
            },
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                 label={rowData?.creationDate}
                 cellSubMenuOptions={{ options: getOptions({ field: "creationDate", isQuickFilterDisplay: rowData?.creationDate }), extraData: { fieldName: "creationDate" ,type : "dateTime"} }}
                 request={rowData}
                  />
            },
        },
        {
            field: "expiryDate",
            headerName: t('general.expiryDate'),
            flex: 1,
            minWidth: 90,
            type: "dateTime",
            valueGetter: (params) => {
                if (!params) return "";
                return new Date(params);
            },
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                 label={rowData?.expiryDate}
                 cellSubMenuOptions={{ options: getOptions({ field: "expiryDate", isQuickFilterDisplay: rowData?.expiryDate }), extraData: { fieldName: "expiryDate" ,type : "dateTime"} }}
                 request={rowData}
                  />
            },
        },
         {
            field: "modeOfSigning",
            headerName:t("general.modeOfSigning"),
            flex: 1,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2 
                label={rowData.modeOfSigning}
                cellSubMenuOptions={{ options: getOptions({ field: "modeOfSigning", isQuickFilterDisplay: Boolean(rowData.modeOfSigning) }), extraData: { fieldName: "modeOfSigning" } }}
                request={rowData}
                 />
            },
        },
        {
            field: "scriveId",
            headerName:t("scrive.scriveId"),
            flex: 1,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2 
                label={rowData.scriveId}
                cellSubMenuOptions={{ options: getOptions({ field: "scriveId", isQuickFilterDisplay: Boolean(rowData.scriveId) }), extraData: { fieldName: "scriveId" } }}
                request={rowData}
                 />
            },
        },
        {
            field: "scriveDocumentStatus",
            headerName:t("scrive.scriveStatus"),
            flex: 1,
            type: "singleSelect",
            valueOptions:scriveStatuses,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                 const value =  rowData.scriveDocumentStatus ? t(`scrive.documentStatus.${rowData.scriveDocumentStatus}` ) : null
                return <LabelColumnV2 
                label={value}
                cellSubMenuOptions={{ options: getOptions({ field: "scriveDocumentStatus", isQuickFilterDisplay: Boolean(rowData.scriveDocumentStatus) }), extraData: { fieldName: "scriveDocumentStatus",type:'singleSelect' } }}
                request={rowData}
                 />
            },
        },
         {
                field: "status",
                download: true,
                headerName: t("general.status"),
                flex: 1,
                minWidth: 90,
                type: "singleSelect",
                valueOptions: Object.values(ContractStatusKeys).map((contactStatusKey) => ({ value: contactStatusKey, label: t(`contract.status.${contactStatusKey}`) })),
                 renderCell: (params) => {
                      const rowData = params.row;
                      if (!rowData) return "";
                      return (
                        <LabelColumnV2
                          label={t(`contract.status.${rowData.status}`)}
                          cellSubMenuOptions={{ options: getOptions({ field: "status", isQuickFilterDisplay: Boolean(rowData.status.toString()) }), extraData: { fieldName: "status", type: "singleSelect" } }}
                          request={rowData}
                        />
                      );
                    },
              },
    ];
}


